
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yolo/[network]",
      function () {
        return require("private-next-pages/yolo/[network]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yolo/[network]"])
      });
    }
  